/**
 * 路由预加载工具
 * 用于在用户悬停菜单时预加载对应的路由模块，提升页面切换速度
 */

// 预加载缓存，避免重复加载
const preloadCache = new Set();

/**
 * 预加载路由模块
 * @param {string} moduleName - 模块名称
 */
export const preloadRoute = (moduleName) => {
  // 如果已经预加载过，直接返回
  if (preloadCache.has(moduleName)) {
    return;
  }

  // 标记为已预加载
  preloadCache.add(moduleName);

  // 根据模块名称动态导入
  const moduleMap = {
    dashboard: () => import('@modules/dashboard'),
    setting: () => import('@modules/setting'),
    businessAffairs: () => import('@modules/businessAffairs'),
    recruitmentManage: () => import('@modules/recruitmentManage'),
    recruitManagement: () => import('@modules/recruitManagement'),
    placeManagement: () => import('@modules/placeManagement'),
    financialManage: () => import('@modules/financialManage'),
    dormitoryManage: () => import('@modules/dormitoryManage'),
    contractMannage: () => import('@modules/contractMannage'),
    warnManage: () => import('@modules/warnManage'),
    salaryManage: () => import('@modules/salaryManage'),
    attendanceManage: () => import('@modules/attendanceManage'),
    ycFinance: () => import('@modules/ycFinance'),
    featureRequirement: () => import('@modules/featureRequirement'),
  };

  const loader = moduleMap[moduleName];
  if (loader) {
    // 预加载但不处理结果
    loader().catch((err) => {
      console.warn(`预加载模块 ${moduleName} 失败:`, err);
      // 失败时从缓存中移除，允许重试
      preloadCache.delete(moduleName);
    });
  }
};

/**
 * 从路由路径提取模块名称
 * @param {string} path - 路由路径
 * @returns {string|null} - 模块名称
 */
export const getModuleNameFromPath = (path) => {
  if (!path) return null;

  const segments = path.split('/').filter(Boolean);
  if (segments.length === 0) return 'dashboard';

  const firstSegment = segments[0];

  // 路径到模块名的映射
  const pathToModule = {
    'setting': 'setting',
    'businessAffairs': 'businessAffairs',
    'recruitmentManage': 'recruitmentManage',
    'recruitManagement': 'recruitManagement',
    'placeManagement': 'placeManagement',
    'financialManage': 'financialManage',
    'dormitoryManage': 'dormitoryManage',
    'contractMannage': 'contractMannage',
    'warnManage': 'warnManage',
    'salaryManage': 'salaryManage',
    'attendanceManage': 'attendanceManage',
    'ycFinance': 'ycFinance',
    'featureRequirement': 'featureRequirement',
  };

  return pathToModule[firstSegment] || null;
};

/**
 * 预加载指定路径的路由
 * @param {string} path - 路由路径
 */
export const preloadRouteByPath = (path) => {
  const moduleName = getModuleNameFromPath(path);
  if (moduleName) {
    preloadRoute(moduleName);
  }
};
